/**
 * Presence-based module loader.
 *
 * Horizon ships ~20 component modules on every page regardless of whether the
 * elements they upgrade are present. This loads each module only once a matching
 * element actually exists in the document, and keeps watching so elements added
 * later (section re-render, quick-add, theme editor) still get upgraded.
 *
 * The selector -> asset URL map is set by snippets/scripts.liquid as window.ppLazyModules.
 */
(function () {
  var map = window.ppLazyModules;
  if (!map) return;

  var selectors = Object.keys(map);
  var loaded = Object.create(null);
  var remaining = selectors.length;

  function load(url) {
    if (loaded[url]) return;
    loaded[url] = true;
    import(url).catch(function (error) {
      console.error('[pp-lazy] failed to load', url, error);
    });
  }

  function scan() {
    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      if (selector === null) continue;

      var url = map[selector];
      if (loaded[url]) {
        selectors[i] = null;
        remaining--;
        continue;
      }

      var match = false;
      try {
        match = document.querySelector(selector) !== null;
      } catch (error) {
        // A malformed selector should never take the whole loader down.
        console.error('[pp-lazy] bad selector', selector, error);
        selectors[i] = null;
        remaining--;
        continue;
      }

      if (match) {
        load(url);
        selectors[i] = null;
        remaining--;
      }
    }
  }

  scan();

  if (remaining <= 0) return;

  // Elements can arrive after first paint: section rendering, quick-add dialogs,
  // cart drawer updates, and theme editor re-renders all inject markup.
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan();
      if (remaining <= 0) observer.disconnect();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Back/forward cache restores can hand us a different document state.
  window.addEventListener('pageshow', function () {
    if (remaining > 0) scan();
  });
})();
